import {
  Directive,
  ElementRef,
  EventEmitter,
  Output,
  AfterViewInit,
  OnDestroy,
} from '@angular/core';

@Directive({
  selector: '[lazyCategories]',
})
export class LazyLoadCategories implements AfterViewInit, OnDestroy {
  @Output() isVisible = new EventEmitter<boolean>();
  private observer!: IntersectionObserver;

  constructor(private el: ElementRef) {}

  ngAfterViewInit(): void {
    console.log('DIRECTIVE');
    this.observer = new IntersectionObserver(([entry]) => {
        console.log('INTERSECTION');
      if (entry.isIntersecting) {
        console.log('isIntersecting');
        this.isVisible.emit(true);
        this.observer.disconnect();
      }
    }, { threshold: 0.1 });
    this.observer.observe(this.el.nativeElement);
  }

  ngOnDestroy(): void {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
}
